import React from 'react';
import PropTypes from 'prop-types';

import { Modal } from 'react-bootstrap';

export default class ImportCalendarModal extends React.Component {

  static propTypes = {
    calendars: PropTypes.array,
    currentDatabase: PropTypes.object,
    shown: PropTypes.bool,
    onCancel: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired
  };

  state = {
    calendar: {}
  }

  calendarIsSelected = (id) => {
    const { calendar } = this.state;

    if (calendar === {}) {
      return false;
    }

    return calendar.id === id;
  }


  handleCalendarSelect = (e) => {
    const { calendars } = this.props;

    const id = e.target.value;
    const calendar = calendars.find(cal => cal.id == id);
    this.setState({ calendar });
  }

  renderCalendarOptions() {
    const { calendars } = this.props;
    const calendarOptions = [];

    (calendars || []).forEach((calendar) => {
      calendarOptions.push(
        <div>
          <div className="d-inline-flex">
            <input
              checked={this.calendarIsSelected(calendar.id)}
              type="radio"
              value={calendar.id}
              onChange={this.handleCalendarSelect}
            />
            <div className="pl-3">{calendar.name}</div>
          </div>
        </div>
      );
    });

    return calendarOptions;
  }

  render() {
    const {
      currentDatabase,
      shown,
      onCancel,
      onSave
    } = this.props;

    const { calendar } = this.state;

    return (
      <Modal className="integration-modal" show={shown} onHide={onCancel}>
        <Modal.Header closeButton>
          <Modal.Title>Import Calendar Events</Modal.Title>
        </Modal.Header>
        <Modal.Body className="mb-3">
          <div className="mt-3">
            Choose which calendar you would like to sync with <strong>"{currentDatabase.name}"</strong>
          </div>
          <div className="mt-2">
            {this.renderCalendarOptions()}
          </div>
          <div className="mt-2">Buildout will import all future and recurring events.</div>
        </Modal.Body>
        <Modal.Footer className="text-left">
          <button className='btn btn-sm btn-cancel' onClick={onCancel}>Cancel</button>
          <button className={'btn btn-sm btn-save' + (calendar.id ? '' : ' disabled')} onClick={() => calendar.id ? onSave(calendar) : ''}>Import & Sync</button>
        </Modal.Footer>
      </Modal>
    );
  }
}
